import React from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';

/** Shared loading and error block for data-backed sections. */
const StatusMessage: React.FC<{ loading: boolean; error: string | null; onRetry?: () => void }> = ({ loading, error, onRetry }) => {
  if (loading) {
    return (
      <div className="d-flex align-items-center gap-2 muted py-3" role="status">
        <Spinner animation="border" size="sm" />
        <span>Loading…</span>
      </div>
    );
  }
  if (error) {
    return (
      <Alert variant="danger" className="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <span>{error}</span>
        {onRetry && (
          <Button variant="outline-danger" size="sm" onClick={onRetry}>
            Retry
          </Button>
        )}
      </Alert>
    );
  }
  return null;
};

export default StatusMessage;
